export default function genererReconductionContrat() {
  return {
    contratId: null,
    dateDebutReconduction: null,
    nMoisReconduction: 1,
    montantAnnuelHt: 0,
    pourcentageTva: 0,
    modeReglementId: null,
    termePaiement: null,
  };
}
